module.exports = __webpack_public_path__ + "static/media/pencil.5762a4f3.svg";